import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CriterioPuntajePage",
    data() {
        let ss = new MainService();
        return {
            msg: "CriterioPuntajePage",
            ss: ss,
            ajax: {
                "url": ss.indexCriterioPuntaje(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'CriterioPuntaje', name: 'CriterioPuntaje', title: 'Criterio de Puntaje' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                { data: 'Activo', name: 'Activo', title: 'Activo', render:function(data, type, row){
                    if (!row.Activo){
                        return '<i class="fa fa-ban text-danger"></i>'; 
                    }
                    else{
                        return '<i class="fa fa-check text-success"></i>'; 
                    }
                } },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            criteriopuntajes: [],
            criteriopuntaje: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newCriterioPuntaje() {
            this.criteriopuntaje = {};
            this.$refs['frm-criteriopuntaje'].show();
        },
        showCriterioPuntaje(id) {
            this.isLoading=true;
            this.ss.showCriterioPuntaje(id).then(
                (result) => {
                    let response = result.data;
                    this.criteriopuntaje = response.data;
                    this.$refs['view-criteriopuntaje'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editCriterioPuntaje() {
            this.$refs['frm-criteriopuntaje'].show();
            this.$refs['view-criteriopuntaje'].hide();
        },
        cancelCriterioPuntaje() {
            if (this.criteriopuntaje.id) {
                this.$refs['view-criteriopuntaje'].show();
            }
            this.$refs['frm-criteriopuntaje'].hide();
        },
        saveCriterioPuntaje() {
            this.ss.storeCriterioPuntaje(this.criteriopuntaje).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-criteriopuntaje'].hide();
                    this.$refs['datatable-criteriopuntaje'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteCriterioPuntaje() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyCriterioPuntaje(this.criteriopuntaje)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-criteriopuntaje'].hide();
                                this.$refs['datatable-criteriopuntaje'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-CriterioPuntaje').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showCriterioPuntaje(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
